export default __webpack_public_path__ + "static/media/ic-structure-3.343489da.svg";